import type { RouteObject } from 'react-router'
import { LoginPage } from '@/features/auth/LoginPage'
import { RequireAuth, RequireWorkspace } from '@/features/auth/RequireAuth'
import { NotFoundPage, RouteError } from '@/features/common/RouteError'
import { AppLayout } from '@/features/layout/AppLayout'
import { PrivacyPage } from '@/features/legal/PrivacyPage'
import { TermsPage } from '@/features/legal/TermsPage'
import { OverviewPage } from '@/features/overview/OverviewPage'
import { PartyPage } from '@/features/party/PartyPage'
import { SetupPage } from '@/features/setup/SetupPage'

/**
 * /login               sign in, or try the demo
 * /setup               create or pick a spreadsheet
 * /                    landing page when signed out (RequireAuth), overview (all parties) when signed in
 * /parties/:partyId    one party's ledger
 * /privacy, /terms     public legal pages (no sign-in, so Google's consent screen can link to them)
 */
export const routes: RouteObject[] = [
  {
    errorElement: <RouteError />,
    children: [
      { path: '/login', element: <LoginPage /> },
      { path: '/privacy', element: <PrivacyPage /> },
      { path: '/terms', element: <TermsPage /> },
      {
        element: <RequireAuth />,
        children: [
          { path: '/setup', element: <SetupPage /> },
          {
            element: <RequireWorkspace />,
            children: [
              {
                element: <AppLayout />,
                children: [
                  { index: true, element: <OverviewPage /> },
                  { path: 'parties/:partyId', element: <PartyPage /> },
                ],
              },
            ],
          },
        ],
      },
      { path: '*', element: <NotFoundPage /> },
    ],
  },
]
